import React from 'react';
import { useTranslation } from 'react-i18next';

import { Alert } from '../../../shared/components/alert/Alert';
import { DropDown } from '../../components/dropDown/DropDown';

function ProfileRegionFields({
  label,
  defaultValue,
  options,
  value,
  onChange,
  hasRegionError,
  hasRegionGroupError,
  regionErrorText,
  regionGroupErrorText,
  isAfterSubmit,
}) {
  const { t } = useTranslation();

  const handleRegionGroupChange = (event) => {
    onChange.regionGroup(event);
  };

  const handleRegionChange = (event) => {
    onChange.region(event);
  };

  return (
    <>
      {options.regionGroup?.length > 0 && (
        <fieldset className={`account_details_container${hasRegionGroupError ? ' error' : ''}`}>
          <legend className="not_logged_label" id="region-group-legend">
            {hasRegionGroupError && isAfterSubmit && (
              <span className="error-indicator">{t('error')}</span>
            )}
            {label.regionGroup}
            {t('input.label.required')}
          </legend>
          <div>
            <div className="select-cont">
              <DropDown
                defaultValue={defaultValue.regionGroup}
                options={options.regionGroup}
                value={value.regionGroup}
                onChange={handleRegionGroupChange}
                id="region-group"
              />
            </div>
          </div>
          <Alert
            id="region-group-error-alert"
            isVisible={hasRegionGroupError}
            message={regionGroupErrorText}
            type="error"
            variant="outline"
            size="md"
          />
        </fieldset>
      )}
      {options.region?.length > 0 && (
        <fieldset className={`account_details_container${hasRegionError ? ' error' : ''}`}>
          <legend className="not_logged_label" id="region-legend">
            {hasRegionError && isAfterSubmit && (
              <span className="error-indicator">{t('error')}</span>
            )}
            {label.region}
            {t('input.label.required')}
          </legend>
          <div>
            <div className="select-cont">
              <DropDown
                defaultValue={defaultValue.region}
                options={options.region}
                value={value.region}
                onChange={handleRegionChange}
                id="region"
              />
            </div>
          </div>
          <Alert
            id="region-error-alert"
            isVisible={hasRegionError}
            message={regionErrorText}
            type="error"
            variant="outline"
            size="md"
          />
        </fieldset>
      )}
    </>
  );
}

export default ProfileRegionFields;
